/*
 * @Author: daringuo
 * @Date: 2018-05-15 18:53:17
 * @Last Modified by:   daringuo
 * @Last Modified time: 2018-05-15 18:53:17
 */
import $$model from '../../model/model.js';
const moduleName = 'game-banner';
import {Carousel, CarouselItem} from 'element-ui';
import Vue from 'vue';
import Bus from '../../model/eventBus.js'
import meCenterTask from '../../model/meCenterTask'
Vue.use(Carousel);
Vue.use(CarouselItem);

let __key = 1;
function getDefaultPage() {
  __key += 1;
  return {
    'appid': 'k_' + __key,
    'img': '//stdl.qq.com/stdl/qb/imgs/pcqbdefault1.png',
    'url': 'javascript:void(0);',
    'name': 'DEFAULT',
    'sub_title': ''
  };
}

export default {
  data() {
    return {
      pages: []
    };
  },
  methods: {
    openGame(url) {
      if (url.match(/https?/)) {
        window.open(url)
      }
      else {
        Bus.$emit('openGameDetail', url)
      }
      meCenterTask.addTaskCount()
    }
  },
  beforeMount() {
    $$model.getData(moduleName, (res) => {
      let datas = [], x = 0, b = 5 - res.length % 5;
      if (b !== 5) {
        for (let j = 0; j < b; j++) {
          res.push(getDefaultPage());
        }
      }
      for (let i = 0; i < res.length; i++) {
        if (datas[x] && datas[x].length >= 5) {
          x += 1;
        }
        if (!datas[x]) {
          datas[x] = [];
        }
        datas[x].push(res[i]);
      }
      this.pages = datas;
      // console.log(moduleName, this.pages);
    });
  },
  mounted() {
    const self = this;
    self.$nextTick(function () {
      const directions = ['LEFT', 'RIGHT'];
      directions.forEach((value) => {
        $(self.$el).find(`.el-carousel__arrow--${value.toLowerCase()}`).each((idx, list) => {
          const $list = $(list);
          $list.attr({'data-log': `BANNER.${value}`});
        });
      });
    });
  }
};
